import { render } from "./mandate.vue?vue&type=template&id=52196f39"
import script from "./mandate.vue?vue&type=script&lang=ts"
export * from "./mandate.vue?vue&type=script&lang=ts"
script.render = render

export default script